import { render, staticRenderFns } from "./BillReceivebleDueDateBadge.vue?vue&type=template&id=4e06eea8"
import script from "./BillReceivebleDueDateBadge.vue?vue&type=script&lang=js"
export * from "./BillReceivebleDueDateBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports